export default __webpack_public_path__ + "static/media/logo1.a17b0f4c.png";